import _ from 'lodash';
import { useCallback } from 'react';
import { useCurrentStateAndParams } from '@uirouter/react';

import { PageHeader } from '@@/PageHeader';
import { LogViewer } from '@@/LogViewer';
import { GetLogsFnType, GetLogsParamsInterface } from '@@/LogViewer/types';

interface Props {
  getLogsFn: GetLogsFnType;
}

export function LogView({ getLogsFn }: Props) {
  const {
    params: { name, namespace },
  } = useCurrentStateAndParams();

  const getLogsWithParamsFn = useCallback(
    ({ timestamps, tail, sinceSeconds }: GetLogsParamsInterface) =>
      getLogsFn(
        _.pickBy({
          timestamps,
          tailLines: tail || 0,
          sinceSeconds,
        })
      ),
    [getLogsFn]
  );

  const breadcrumbs = [
    { label: 'Namespaces', link: 'kubernetes.resourcePools' },
    {
      label: namespace,
      link: 'kubernetes.resourcePools.resourcePool',
      linkParams: { id: namespace },
    },
    { label: 'Applications', link: 'kubernetes.applications' },
    'Stacks',
    name,
    'Logs',
  ];

  return (
    <>
      <PageHeader title="Stack logs" breadcrumbs={breadcrumbs} reload />
      <LogViewer
        resourceType="kube-stack"
        resourceName={name}
        getLogsFn={getLogsWithParamsFn}
        useTimeOptions
      />
    </>
  );
}
